// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/portable-elt-signal-optimization.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/portable-elt-signal-optimization/portable-elt-signal-optimization.js';

mount([g0]);
